import type { Cue } from '@core/model/cue.ts';
import type { Settings } from '@core/settings/schema.ts';
import { maskDictationText } from './maskText.ts';

export type DictationCue = Cue & {
  dictationRaw?: string;
  dictationTyped?: string;
  completed?: boolean;
};

export type DictationApplySettings = Pick<
  Settings,
  'dictationFilteredWords' | 'dictationIgnoreBracketedText'
>;

export function injectDictation(cues: DictationCue[], settings: DictationApplySettings): void {
  for (let i = 0; i < cues.length; i += 1) {
    const cue = cues[i]!;
    const masked = maskDictationText(cue.text, settings);
    cue.dictation = masked;
    cue.dictationRaw = cue.text.replace(/<br\s*\/?>/gi, '\n');
    cue.dictationTyped = '';
    cue.completed = masked.indexOf('_') === -1;
  }
}

/** Speaking reuses dictation infra without underscore masks. */
export function injectSpeakingLocks(cues: DictationCue[]): void {
  for (let i = 0; i < cues.length; i += 1) {
    const cue = cues[i]!;
    delete cue.dictation;
    cue.dictationRaw = cue.text.replace(/<br\s*\/?>/gi, '\n');
    cue.dictationTyped = '';
    cue.completed = false;
  }
}

export function removeDictation(cues: DictationCue[]): void {
  for (let i = 0; i < cues.length; i += 1) {
    const cue = cues[i]!;
    delete cue.dictation;
    delete cue.dictationRaw;
    delete cue.dictationTyped;
    delete cue.completed;
  }
}

export function applyDictationToCues(
  cues: Cue[],
  settings: DictationApplySettings,
  speakingMode: boolean,
): DictationCue[] {
  const next = cues.map((c) => ({ ...c })) as DictationCue[];
  if (speakingMode) {
    injectSpeakingLocks(next);
  } else {
    injectDictation(next, settings);
  }
  return next;
}
